import { useFilter } from 'rwl-ui';
import { useGlobal } from '../../hooks';
import { configToFilters } from './transformers';
import { useEffect } from 'react';

export const FilterFetcher = (): null => {
    const { config } = useGlobal();
    const { replaceFilterGroups } = useFilter();

    useEffect(() => {
        if (config) {
            replaceFilterGroups(configToFilters(config));
        }
    }, [config]);

    return null;
};
